<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/performanceUnitList' }">绩效单元</el-breadcrumb-item>
                <el-breadcrumb-item>绩效单元{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :class="in_array(item.prop, ['business_unit_rid', 'master_code', 'person_code']) ? 'is-required' : ''"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'el-select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-select
                                        v-model="formData[item.prop]"
                                        filterable
                                        clearable
                                        multiple
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                    >
                                        <el-option
                                            v-for="item in options[item.prop]"
                                            :key="item.value"
                                            :label="item.name"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                    class="is-required"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                    :class="in_array(item.prop, ['name', 'period_code']) ? 'is-required' : ''"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="item['prop'] == 'aaaaa' || (item['prop'] == 'achievement_rate_split_point' && !(parseFloat(formData.standard_quota_rate_over) > 0))"
                                        clearable
                                    ></el-input>
                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>

                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit, checkNaturalNumber, checkNumber } from '@/js/common.js';

export default {
    name: 'performanceUnitEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {}, // 表单验证信息
            options: {}
        };
    },
    created() {
        this.$api['dropdownPerformanceTypeSign']({})
            .then((res) => {
                if (res.code == 0) {
                    this.options['type_sign'] = res.data;
                    this.initFormData();
                }
            })
            .catch((error) => {});

        this.$api['dropdownPerformanceLockSign']({})
            .then((res) => {
                if (res.code == 0) {
                    this.options['lock_sign'] = res.data;
                    this.initFormData();
                }
            })
            .catch((error) => {});

        this.$api['dropdownPerformanceBaseFactorSign']({})
            .then((res) => {
                if (res.code == 0) {
                    this.options['base_factor_sign'] = res.data;
                    this.initFormData();
                }
            })
            .catch((error) => {});
        this.$api['dropdownPerson']({})
            .then((res) => {
                if (res.code == 0) {
                    this.options['visible_person_codes'] = res.data.map((item) => {
                        return {
                            ...item,
                            value: item.code
                        };
                    });
                    this.initFormData();
                }
            })
            .catch((error) => {});
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.target_achievement_rate_basis_code = 1;
            this.data.base_basis_code = 1;
            this.data.base_type_code = 3;
        }
    },
    methods: {
        in_array,
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                business_unit_rid: {
                    request_uri: 'dropdownBusinessUnits',
                    title: '业务单元',
                    ref: 'business_unit_rid_ref',
                    type: 'dropdown'
                },
                person_code: {
                    request_uri: 'dropdownPerson',
                    title: '人员',
                    ref: 'person_code_ref',
                    type: 'dropdown',
                    select_value: 'code'
                },
                parent_code: {
                    request_uri: 'dropdownPerformanceUnit',
                    title: '父级单元',
                    ref: 'parent_code_ref',
                    type: 'dropdown',
                    select_value: 'code'
                },
                target_achievement_rate_basis_code: {
                    request_uri: 'dropdownTargetAchievementRateBasis',
                    title: '达成率依据',
                    ref: 'target_achievement_rate_basis_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                base_basis_code: {
                    request_uri: 'dropdownBaseBasis',
                    title: '基础基数依据',
                    ref: 'base_basis_code_ref',
                    type: 'dropdown',
                    select_value: 'value',
                    tips: '绩效产品行计算基础基数依据，基础绩效单元必填。不填默认PT'
                },
                base_type_code: {
                    request_uri: 'dropdownBaseType',
                    title: '基数类型',
                    ref: 'base_type_code_ref',
                    type: 'dropdown',
                    select_value: 'value',
                    tips: '选择某一指标作为基数，非基础绩效单元必填。不填默认基础基数'
                },
                parameter_function_rid: {
                    request_uri: 'dropdownParameterFunction',
                    title: '函数',
                    ref: 'parameter_function_rid_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                progress_type_code: {
                    request_uri: 'dropdownParameterProgress',
                    title: '进度类型',
                    ref: 'progress_type_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                target_achievement_rate: {
                    tips: '当达成率依据为自定义可修改，否则修改无效'
                },
                type_sign: {
                    title: '类型标识',
                    ref: 'type_sign_ref',
                    type: 'el-select',
                    tips: '可多选'
                },
                lock_sign: {
                    title: '锁定标识',
                    ref: 'lock_sign_ref',
                    type: 'el-select',
                    tips: '可多选'
                },
                base_factor_sign: {
                    title: '基数因子标识',
                    ref: 'base_factor_sign_ref',
                    type: 'el-select',
                    tips: '可多选'
                },
                visible_person_codes: {
                    title: '可见人',
                    ref: 'visible_person_codes_ref',
                    type: 'el-select',
                    tips: '可多选',
                    select_value: 'code'
                }
            };
        },
        initFormRule() {
            this.rules = {
                person_code: [{ required: true, message: '请选择人员', trigger: 'blur' }],
                business_unit_rid: [{ required: true, message: '请选择业务单元', trigger: 'blur' }],
                period_code: [{ required: true, message: '请输入期间编码', trigger: 'blur' }],
                depth_increment: { validator: checkNaturalNumber, trigger: 'blur' },
                label: [{ required: false, message: '请输入标签', trigger: 'blur' }],
                target_achievement_rate_basis_code: [{ required: true, message: '请选择达成率依据', trigger: 'blur' }],
                base_basis_code: [{ required: false, message: '请选择基础基数依据', trigger: 'blur' }],
                base_type_code: [{ required: false, message: '请选择基数类型', trigger: 'blur' }],
                parameter_function_rid: [{ required: true, message: '请选择函数', trigger: 'blur' }],
                progress_type_code: [{ required: true, message: '请选择进度类型', trigger: 'blur' }],
                standard_quota_rate: { required: true, validator: checkNumber, trigger: 'blur' },
                standard_quota_rate_over: { required: false, validator: checkNumber, trigger: 'blur' },
                achievement_rate_split_point: { required: false, validator: checkNumber, trigger: 'blur' },
                hierarchy_factor: { required: true, validator: checkNumber, trigger: 'blur' },
                factor: { required: true, validator: checkNumber, trigger: 'blur' },
                factor2: { required: true, validator: checkNumber, trigger: 'blur' },
                factor1: { required: true, validator: checkNumber, trigger: 'blur' },
                factor3: { required: true, validator: checkNumber, trigger: 'blur' },
                factor4: { required: true, validator: checkNumber, trigger: 'blur' },
                target_achievement_rate_effective_point: { required: true, validator: checkNumber, trigger: 'blur' },
                target_achievement_rate: { required: true, validator: checkNumber, trigger: 'blur' },
                quota_ceiling: { required: true, validator: checkNumber, trigger: 'blur' },
                quota_adjustment: { required: true, validator: checkNumber, trigger: 'blur' },
                quota_released_rate: { required: true, validator: checkNumber, trigger: 'blur' },
                type_sign: [{ required: false, message: '类型标识', trigger: 'blur' }],
                lock_sign: [{ required: false, message: '锁定标识', trigger: 'blur' }],
                base_factor_sign: [{ required: false, message: '基数因子标识', trigger: 'blur' }],
                visible_person_codes: [{ required: false, message: '可见人', trigger: 'blur' }]
            };
        },

        initQueryParams() {
            this.queryParams.id = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                id: this.data.id || '0',
                person_code: this.data.person_code || '',
                business_unit_rid: this.data.business_unit_rid || '',
                period_code: this.data.period_code || '',
                parent_code: this.data.parent_code || '',
                depth_increment: this.data.depth_increment || '0',
                label: this.data.label || '',
                target_achievement_rate_basis_code: this.data.target_achievement_rate_basis_code || 1,
                base_basis_code: this.data.base_basis_code || 1,
                base_type_code: this.data.base_type_code || 3,
                parameter_function_rid: this.data.parameter_function_rid || '',
                progress_type_code: this.data.progress_type_code || '',
                progress_type_mark: this.data.progress_type_mark || '',
                standard_quota_rate: this.data.standard_quota_rate || '0',
                standard_quota_rate_over: this.data.standard_quota_rate_over || '0',
                achievement_rate_split_point: this.data.achievement_rate_split_point || '1',
                hierarchy_factor: this.data.hierarchy_factor || '0',
                factor: this.data.factor || '0',
                factor1: this.data.factor1 || '0',
                factor2: this.data.factor2 || '0',
                factor3: this.data.factor3 || '0',
                factor4: this.data.factor4 || '0',
                target_achievement_rate_effective_point: this.data.target_achievement_rate_effective_point || '0',
                target_achievement_rate: this.data.target_achievement_rate || '0',
                quota_ceiling: this.data.quota_ceiling || '0',
                quota_adjustment: this.data.quota_adjustment || '0',
                quota_released_rate: this.data.quota_released_rate || '0',
                type_sign: this.data.type_sign_array || [],
                lock_sign: this.data.lock_sign_array || [],
                base_factor_sign: this.data.base_factor_sign_array || [],
                visible_person_codes: this.data.visible_person_codes || []
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).performance_unit;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'parent_code',
                        'business_unit_rid',
                        'period_code',
                        'depth_increment',
                        'label',
                        'standard_quota_rate',
                        'standard_quota_rate_over',
                        'achievement_rate_split_point',
                        'hierarchy_factor',
                        'factor',
                        'factor1',
                        'factor2',
                        'factor3',
                        'factor4',
                        'target_achievement_rate_effective_point',
                        'target_achievement_rate',
                        'quota_ceiling',
                        'quota_adjustment',
                        'quota_released_rate'
                    ]
                },
                {
                    person: 'person_code',
                    target_achievement_rate_basis_code_label: 'target_achievement_rate_basis_code',
                    base_basis_code_label: 'base_basis_code',
                    base_type_code_label: 'base_type_code',
                    type_sign_label: 'type_sign',
                    lock_sign_label: 'lock_sign',
                    base_factor_sign_label: 'base_factor_sign',
                    parameter_function_rid_label: 'parameter_function_rid',
                    progress_type_mark: 'progress_type_code',
                    visible_person: 'visible_person_codes'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: 'performanceUnitList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .performanceUnitDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'performanceUnitUpdate';
            } else {
                uri = 'performanceUnitInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>